import { getRAID } from './getRAID';

export const setRAIDInput = () => {
  const RAIDElements = document.getElementsByName('ramsey_anonymous_id');
  if (RAIDElements.length) {
    const RAID = getRAID();
    Array.prototype.forEach.call(RAIDElements, (input) => (input.value = RAID));
  }
};
